import type { FC } from "react";
import { EditableAmountRow } from "web_myplann/Finances/Components/EditableAmountRow";
import type { ExpenseFormEntry } from "web_myplann/Finances/Forms/expenseEntrySchema";
import { formatExpenseSubtitle } from "web_myplann/Finances/Helpers/formatExpenseSubtitle";
import type { IndexedExpense } from "web_myplann/Finances/Helpers/groupExpensesByType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	items: IndexedExpense<ExpenseFormEntry>[];
	onEdit: (index: number) => void;
	onRemove: (index: number) => void;
};

export const ExpenseRowList: FC<Props> = ({ items, onEdit, onRemove }) => {
	const { t } = useResource();
	const currencySign = t(Resources.Common.CurrencySign);
	const minimumLabel = t(Resources.Finances.Expenses.minimumValueShort);

	return (
		<>
			{items.map(({ index, expense }) => (
				<EditableAmountRow
					key={`${expense.type}-${expense.name}`}
					title={t(Resources.Finances.Expenses.Names[expense.name])}
					subtitle={formatExpenseSubtitle(expense, currencySign, minimumLabel)}
					variant="secondary"
					onEdit={() => onEdit(index)}
					onRemove={() => onRemove(index)}
				/>
			))}
		</>
	);
};
